import '@/assets/css/style.scss';
if (import.meta.env.VITE_INCLUDE_COMMON === 'true') {
  import('@/assets/css/global-footer.css');
  import('@/assets/js/common/loadHeaderFooter.js').then(module => {
    const loadHeaderFooter = module.default;
    loadHeaderFooter();
  });
  import('@/assets/js/common/components/login.js');
}

import { createApp, ref, onMounted } from './vue.esm-browser.prod.js';
import { reportData } from './data';
import './common/k-tools/k-tools.css';
import { KAnchor, KScrollTrigger } from './common/k-tools/k-tools.js';
import LazyLoad from 'vanilla-lazyload';
// import Swiper bundle with all modules installed
import { Swiper } from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';
import { gsapAnimation, gsapAnimationUpdate } from './common/gsapAnimation';

const swiperHandler = {};
swiperHandler.threeNoes = function () {
  const threeNoesSwiper = new Swiper('.threeNoes__swiper', {
    slidesPerView: 1,
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
    },
    navigation: {
      nextEl: '.threeNoes__swiper .swiper-button-next',
      prevEl: '.threeNoes__swiper .swiper-button-prev',
    },
    pagination: {
      el: '.threeNoes__swiper .swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      1000: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });
};

const pageInitial = () => {
  const lazyLoadInstance = new LazyLoad({});
  const anchor = new KAnchor('[k-anchor]');
  const scrollTrigger = new KScrollTrigger('[k-st]', {
    start: 'top 80%',
    // marker: true,
  });

  gsapAnimation();
  swiperHandler.threeNoes();
};

// Vue
createApp({
  setup() {
    const reportDataRef = ref(reportData);
    onMounted(() => {
      setTimeout(() => {
        pageInitial();
      }, 200);
    });
    return {
      reportDataRef,
    };
  },
}).mount('#main');
